var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-card',{attrs:{"shadow":"never"}},[_c('Notes',{ref:"notes",attrs:{"resource":"account","identifier":_vm.$route.params.accountId,"truncate":"","paginate":"","limit":10}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }